import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';

const styles = {
  root: {
    margin: 30,
    padding: 48,
    border: '3px solid #e0e0e0',
    borderRadius: 6,
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 200,
  },
  title: {
    fontSize: 22,
    fontWeight: 500,
    marginBottom: 16,
  },
  body: {
    fontSize: 16,
    color: '#555555',
    lineHeight: 1.6,
    maxWidth: 520,
  },
};

const texts = {
  noParagraphs: {
    title: 'Nessun paragrafo presente',
    body: 'Aggiungi almeno un paragrafo per continuare a compilare il manuale personalizzato. Puoi usare il pulsante «Aggiungi Paragrafo» nel pannello a sinistra.',
  },
  noChapters: {
    title: 'Nessun capitolo presente',
    body: 'Aggiungi un capitolo per iniziare a creare il tuo nuovo manuale personalizzato. Puoi usare il pulsante «Aggiungi Capitolo» nel pannello a sinistra.',
  },
  noParagraphsInChapter: (chapterName) => ({
    title: `Nessun paragrafo nel capitolo "${chapterName}"`,
    body: 'Aggiungi almeno un paragrafo a questo capitolo per continuare a compilare il manuale personalizzato. Puoi usare il pulsante «Aggiungi Paragrafo» nel pannello a sinistra.',
  }),
};

const getTexts = (chapterMode, chapterName, hasChapters) => {
  if (chapterMode && !hasChapters) {
    return texts.noChapters;
  } else if (chapterMode && chapterName) {
    return texts.noParagraphsInChapter(chapterName);
  }
  return texts.noParagraphs;
};

function EmptyManualView({ classes, chapterMode, chapterName, hasChapters }) {
  const { title, body } = getTexts(chapterMode, chapterName, hasChapters);

  const testId =
    chapterMode && !hasChapters
      ? 'empty-manual-view-no-chapters'
      : 'empty-manual-view-no-paragraphs';

  return (
    <Box className={classes.root} data-testid={testId}>
      <Typography className={classes.title} component="h2">
        {title}
      </Typography>
      <Typography className={classes.body} component="p">
        {body}
      </Typography>
    </Box>
  );
}

EmptyManualView.propTypes = {
  classes: PropTypes.object.isRequired,
  chapterMode: PropTypes.bool,
  chapterName: PropTypes.string,
  hasChapters: PropTypes.bool,
};

EmptyManualView.defaultProps = {
  chapterMode: false,
  chapterName: null,
  hasChapters: true,
};

export default withStyles(styles)(EmptyManualView);
